import { useVideoStreamController_getLocationStreamsStatus } from '@/services/hooks';

import { type DomainQuery, useMappedQuery } from '../shared/query';

/**
 * One bioscope's live-stream state at a location: the fields of `LocationStreamStatusDto` the
 * video page reads. Each row is checked before use; the video page spreads the row into its
 * store as it is, so fields beyond these are kept.
 */
export interface LocationStream {
    bioscopeId: number;
    cageId?: number;
    cageName?: string;
    stream?: {
        bioscope_id: number;
        mux_stream_id?: string;
        status?: string;
        timestamp?: string;
        started_by_user_id?: number | null;
        playback_id?: string | null;
    } | null;
    [field: string]: unknown;
}

function isLocationStream(row: unknown): row is LocationStream {
    return (
        typeof row === 'object' &&
        row !== null &&
        'bioscopeId' in row &&
        typeof row.bioscopeId === 'number'
    );
}

/** The rows that describe a bioscope; anything but a list reads as none. */
export function toLocationStreams(body: unknown): LocationStream[] {
    return Array.isArray(body) ? body.filter(isLocationStream) : [];
}

/** The live-stream state of every bioscope at the location. */
export function useGetLocationStreams(locationId: number): DomainQuery<LocationStream[]> {
    return useMappedQuery(
        useVideoStreamController_getLocationStreamsStatus(locationId),
        toLocationStreams
    );
}
